
import {initWebComponent} from "@/helpers/web-component-helper";
import {WizardComponent} from "@/components/wizard/wizard-component";

const template = document.createElement('template');

export class WizardNavItemComponent extends HTMLElement {
    constructor() {
        super();

        const name = this.getAttribute('data-name')
        const key = parseInt(this.getAttribute('data-key')) + 1

        template.innerHTML = `
        <li class="nav-item">
            <a class="nav-link" href="#step-` + key + `">
                <div class="num">` + key + `</div>
                <span class="d-none d-md-block">` + name + `</span>
            </a>
        </li>
        `;

        initWebComponent(this, template)
    }
}


